import React from 'react';
import { X } from 'lucide-react';
import type { AggregatedRow } from './types';
import { formatMetric } from './utils';

type DetailPanelProps = {
  item: AggregatedRow;
  totalMetric: number;
  metricLabel: string;
  unit: string;
  onClose: () => void;
};

export function DetailPanel({ item, totalMetric, metricLabel, unit, onClose }: DetailPanelProps) {
  const percentageOfTotal = totalMetric > 0 ? (item.metricValue / totalMetric) * 100 : 0;

  return (
    <div className="flex h-full flex-col rounded-lg border border-primary/20 bg-primary/5 p-3">
      <div className="mb-3 flex items-start justify-between">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-primary">Detalle</h4>
        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar detalle"
          className="rounded p-0.5 text-gray-400 transition hover:bg-gray-200 hover:text-gray-600"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="mb-4">
        <p className="line-clamp-2 text-sm font-semibold text-gray-900" title={item.label}>
          {item.label}
        </p>
        {item.secondaryLabel ? (
          <p className="text-xs text-gray-500">ID: {item.secondaryLabel}</p>
        ) : null}
      </div>

      <div className="space-y-3">
        <div>
          <p className="text-xs text-gray-500">{metricLabel}</p>
          <p className="text-lg font-bold text-primary">
            {formatMetric(item.metricValue)} {unit}
          </p>
        </div>

        <div>
          <p className="text-xs text-gray-500">Participacion</p>
          <p className="text-lg font-bold text-gray-900">{percentageOfTotal.toFixed(1)}%</p>
          <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
            <div
              className="h-full rounded-full bg-primary transition-all duration-300"
              style={{ width: `${Math.min(percentageOfTotal, 100)}%` }}
            />
          </div>
        </div>

        <div>
          <p className="text-xs text-gray-500">Conteo</p>
          <p className="text-lg font-bold text-gray-900">{item.count.toLocaleString('es-CO')}</p>
        </div>
      </div>
    </div>
  );
}
